import { CounterUnit } from './constants';

export function parseUnits(value?: string): CounterUnit[] {
	return value?.split(',').map(unit => parseInt(unit, 10) as CounterUnit) ?? [];
}
